





















































import Vue from 'vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import BuyingOptions from  '@/product/components/BuyingOptions.vue'
import SelectAddon from '@/product/components/addonOptions/SelectAddon.vue'
import SelectAddonMobile from '@/product/components/addonOptions/SelectAddonMobile.vue'

import {
  ProductState,
  BuyingOption,
  PRODUCT_SELECTION_ERROR_TYPES,
  AddonProduct,
  AddonProductOption
} from '@/product/types'
import { ADDON_PRODUCT_NONE } from '@/product/const'

export default Vue.extend({
  components: {
    SectionTitle,
    BuyingOptions,
    SelectAddon,
    SelectAddonMobile
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    isBuyingAddon: boolean
    selectedAddonProductId?: string
    selectedAddonFirstOptionId?: string
  } {
    return {
      isBuyingAddon: true,
      selectedAddonProductId: undefined,
      selectedAddonFirstOptionId: undefined
    }
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    buyingAddonOptions(): BuyingOption[] {
      return [
        {
          displayName: this.isMobile ? '購入する' : '付属品を購入する',
          isBuying: true,
          isDisabled: false
        },
        {
          displayName: this.isMobile ? '購入しない' : '付属品を購入しない',
          isBuying: false,
          isDisabled: false
        }
      ]
    },
    addonProducts(): AddonProduct[] {
      return this.storeState.addonProducts || []
    },
    outOfStockOptions(): { [key: string]: string } {
      return this.addonProducts.reduce((obj: {[key: string]: string}, product) => {
        const soldOutOptions = product.sku.firstOptions.filter(option => !option.hasStock)
          .map(option => option.displayName).join(', ')
        obj[product.product.id] = soldOutOptions
        return obj
      }, {})
    },
    selectedAddonProductName(): string {
      return this.storeState.addonProducts?.find(
        addonProduct => addonProduct.product.id === this.selectedAddonProductId
      )?.product.displayName || ''
    },
    showHighlightAddonProductSelection(): boolean {
      return this.storeState.selectionErrors[PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SET].highlightInvalidElement
    },
    errorMessage(): string {
      return this.storeState.selectionErrors[PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SET].errorMessage
    }
  },
  watch: {
    selectedAddonFirstOptionId(id) {
      if (id) this.updateAddonProduct(this.selectedAddonProductId, id)
    }
  },
  created() {
    const initAddonProductId = this.storeState.addonProduct?.selectedAddonProductId
    const initAddonFirstOptionId =
      this.storeState.addonProduct?.selectedAddonFirstOptionId
    if (initAddonProductId) {
      if (initAddonProductId === ADDON_PRODUCT_NONE) {
        this.isBuyingAddon = false
      } else {
        this.isBuyingAddon = true
        this.selectedAddonProductId = initAddonProductId
      }
    }
    if (initAddonFirstOptionId) {
      this.selectedAddonFirstOptionId = initAddonFirstOptionId
    }
  },
  methods: {
    setBuyingAddon(option: boolean) {
      if (!option) {
        this.selectedAddonProductId = undefined
        this.selectedAddonFirstOptionId = undefined
        this.updateAddonProduct(ADDON_PRODUCT_NONE, undefined)
      } else {
        this.updateAddonProduct(undefined, undefined)
      }

      this.isBuyingAddon = option
    },
    setSelectAddonProduct(id?: string) {
      if (id) this.selectedAddonProductId = id
    },
    setSelectedAddonFirstOptionId(id: string): void {
      this.selectedAddonFirstOptionId = id
    },
    updateModalAddonProduct(value: {
      selectedAddonProductId?: string
      selectedAddonFirstOptionId?: string
    }) {
      this.selectedAddonProductId = value.selectedAddonProductId
      this.selectedAddonFirstOptionId = value.selectedAddonFirstOptionId
      this.updateAddonProduct(
        value.selectedAddonProductId,
        value.selectedAddonFirstOptionId
      )
    },
    updateAddonProduct(addonId?: string, firstOptionId?: string) {
      if (this.showHighlightAddonProductSelection) {
        this.$store.commit('solveSelectErrorItem', PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SET)
      }
      const payload = {
        selectedAddonProductId: addonId,
        selectedAddonFirstOptionId: firstOptionId
      } as AddonProductOption
      this.$store.commit('setAddonProduct', payload)
      this.$emit('update')
    }
  }
})
